import { useRemoveInvitees } from '@/hooks/useRemoveInvite'
import { Trash } from '@mynaui/icons-react'
import { Avatar, AvatarFallback } from '@radix-ui/react-avatar'
import { Text } from './custom-components'
import { Badge } from './shadcn/badge'
import { Button } from './shadcn/button'
import { Dialog, DialogContent, DialogPortal } from './shadcn/dialog'

const Invitee = ({
  member,
}: {
  member: {
    id: string
    email: string
    firstName: string | null
    lastName: string | null
    role: 'owner' | 'commenter' | 'creator'
    status: 'accepted' | 'rejected' | 'pending'
    hasExpired: boolean
  }
}) => {
  const { isRemovingInvite, removeInvite, open, onOpenChange, inviteeIdToRemove, setInviteeIdToRemove } =
    useRemoveInvitees()
  return (
    <>
      <Dialog open={open} onOpenChange={isRemovingInvite ? undefined : onOpenChange}>
        <DialogPortal>
          <DialogContent
            className={
              'max-w-md w-full p-6 gap-6 flex flex-col items-center justify-center bg-themebackground dark:bg-themebackgrounddark'
            }
          >
            <Text size={'xxl'} weight={'semibold'} className="w-fit">
              Warning! 🚨
            </Text>
            <Text size={'lg'} weight={'normal'} className="text-thememutedforeground w-fit">
              {'You’re removing an invite – are you sure?'}
            </Text>

            <Button
              variant={'destructive'}
              className="w-full"
              loading={isRemovingInvite}
              disabled={isRemovingInvite}
              onClick={() =>
                inviteeIdToRemove ? removeInvite({ invitationId: inviteeIdToRemove }) : onOpenChange(false)
              }
            >
              Confirm
            </Button>
          </DialogContent>
        </DialogPortal>
      </Dialog>

      <div key={member.email} className="flex justify-between items-center gap-10">
        <div className="flex items-center gap-3">
          <Avatar className="min-w-8 w-8 h-8 rounded-full bg-themesidebar dark:bg-themesidebardark flex items-center justify-center border border-thememutedforeground border-dashed">
            <AvatarFallback>
              {member.firstName || member.lastName
                ? `${member.firstName?.[0] ?? ''}${member.lastName?.[0] ?? ''}`.toUpperCase()
                : member.email?.[0]?.toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <Text size="sm" weight="medium">
            {member.firstName || member.lastName
              ? `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim()
              : member.email}
          </Text>
        </div>

        <div className="flex items-center gap-2">
          <Badge variant="outline" className="font-normal">
            {`${member.status[0].toUpperCase()}${member.status.substring(1)}`}
          </Badge>
          {member.status == 'rejected' || member.status == 'pending' ? (
            <div
              onClick={() => {
                setInviteeIdToRemove(member.id)
                onOpenChange(true)
              }}
              className="flex items-center gap-1 p-1.5 !text-sm cursor-pointer hover:bg-slate-100 dark:hover:text-slate-50 rounded-md text-red-500"
            >
              <Trash className="max-w-4" />
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default Invitee
